customElements.define('recess-mobile-menu', class RecessMobileMenu extends HTMLElement {
  constructor() {
    super();

    this.mobileMenuIsOpen = false;

    this.activeParentLinksIndex = -1;
    this.activeChildLinksIndex = -1;

    this.menuButtonEl = this.querySelector('#headerMenuMobileMenuButton');
    this.parentLinkNodelist = this.querySelectorAll('.parent-link[data-levels="1"], .parent-link[data-levels="2"]');
    this.childLinkNodelist = this.querySelectorAll('.child-link[data-levels="1"]');
    this.searchFormEl = this.querySelector('.search-form.parent-link');
    this.logInEl = this.querySelector('.header-submenu__account-menu');

    this.menuButtonEl.addEventListener('click', () => {
      this.toggleMobileMenuIsOpen();
    });

    this.parentLinkNodelist.forEach(parentLinkEl => {
      parentLinkEl.addEventListener('click', event => {
        event.preventDefault();
        const { target } = event;
        this.activeParentLinksIndex = target.closest('.parent-link-wrapper').dataset.parentIndex;
        this.render();
      });
    });

    this.querySelectorAll('.child-links-back-button').forEach(buttonEl => {
      buttonEl.addEventListener('click', event => {
        this.activeParentLinksIndex = -1;
        this.activeChildLinksIndex = -1;
        this.render();
      });
    });

    this.childLinkNodelist.forEach(childLinkEl => {
      childLinkEl.addEventListener('click', event => {
        event.preventDefault();
        const { target } = event;
        this.activeChildLinksIndex = this.activeChildLinksIndex == target.closest('.child-link-wrapper').dataset.childIndex ?
          -1 :
          target.closest('.child-link-wrapper').dataset.childIndex;
        this.render();
      });
    });
  }

  toggleMobileMenuIsOpen() {
    if(this.mobileMenuIsOpen) {
      this.mobileMenuIsOpen = false;
      this.activeParentLinksIndex = -1;
    } else {
      this.mobileMenuIsOpen = true;
    }

    this.render();
  }

  render() {
    this.querySelector('.header-submenu').classList.toggle('open', this.mobileMenuIsOpen);
    document.documentElement.classList.toggle('header-submenu--open', this.mobileMenuIsOpen);

    this.parentLinkNodelist.forEach(el => {
      el.classList.toggle('active', this.activeParentLinksIndex == el.dataset.parentIndex);
      el.setAttribute('aria-expanded', this.activeParentLinksIndex == el.dataset.parentIndex);
    });

    this.childLinkNodelist.forEach(el => {
      el.classList.toggle('active', this.activeChildLinksIndex == el.dataset.childIndex);
      el.setAttribute('aria-expanded', this.activeChildLinksIndex == el.dataset.childIndex);
      el.closest('.child-link-wrapper').classList.toggle('active', this.activeChildLinksIndex == el.dataset.childIndex);
    });

     if (this.searchFormEl.classList.contains('active')) {
       this.logInEl.classList.add('hidden');
     } else {
      this.logInEl.classList.remove('hidden');
     }
  }
});
